export default __webpack_public_path__ + "static/linkedin-17e919bb623c20be8b808bcdd220c1ca.png";